import { Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useDispatch, useSelector } from "react-redux";

import { palette } from "../../../theme/palette";

import {
  driverProfileEditSelector,
  newDriverProfileEditSelector,
} from "../../../reducers/driverManagement/selectors";
import {
  setNewDriverProfileEdit,
  setSelectingDriverLocation,
  updateDriverProfileEdit,
} from "../../../reducers/driverManagement/thunkActions";

import { View } from "../../View";
import { ActionButton } from "../../Subheaders/Common/ActionButton";

const useStyles = makeStyles({
  container: {
    position: "absolute",
    top: "1rem",
    left: "2rem",
    borderRadius: "0.4rem 0.4rem",
    backgroundColor: palette.dpdLightGrey,
    padding: "0.4rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 101,
  },
  title: {
    margin: "0rem 0.8rem",
  },
});

export const SelectDriverLocationModal = ({ selectingDriverLocation }) => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const newDriverProfileEdit = useSelector(newDriverProfileEditSelector);
  const driverProfileEdit = useSelector(driverProfileEditSelector);
  const { [`${selectingDriverLocation}Postcode`]: postcode } =
    newDriverProfileEdit || driverProfileEdit || {};

  return (
    <View className={styles.container}>
      <Typography className={styles.title}>
        {`SELECT DRIVER ${
          selectingDriverLocation === "start" ? "START" : "END"
        } LOCATION`}
      </Typography>
      <ActionButton
        variant={"blue"}
        disabled={!postcode}
        onClick={() => dispatch(setSelectingDriverLocation(null))}
      >
        Accept
      </ActionButton>
      <ActionButton
        variant={"red"}
        onClick={() => {
          if (newDriverProfileEdit)
            dispatch(
              setNewDriverProfileEdit({
                ...newDriverProfileEdit,
                [`${selectingDriverLocation}Postcode`]: null,
                [`${selectingDriverLocation}Latitude`]: null,
                [`${selectingDriverLocation}Longitude`]: null,
              })
            );
          else if (driverProfileEdit)
            dispatch(
              updateDriverProfileEdit({
                updates: [
                  { name: `${selectingDriverLocation}Postcode`, value: null },
                  { name: `${selectingDriverLocation}Latitude`, value: null },
                  { name: `${selectingDriverLocation}Longitude`, value: null },
                ],
              })
            );
          dispatch(setSelectingDriverLocation(null));
        }}
      >
        Cancel
      </ActionButton>
    </View>
  );
};
